import { render } from "./PlayerManagement.vue?vue&type=template&id=3dfeeb3a&scoped=true"
import script from "./PlayerManagement.vue?vue&type=script&lang=js"
export * from "./PlayerManagement.vue?vue&type=script&lang=js"

import "./PlayerManagement.vue?vue&type=style&index=0&id=3dfeeb3a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dfeeb3a"]])

export default __exports__